<template>
  <div class="system_order_list">
    <!-- 用户统计 -->
    <el-form v-model="queryData">
      <el-date-picker
        v-model="date"
        style="width: 380px"
        :fit="true"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="time"
      />
      <el-input
        v-model.trim="queryData.mobile"
        style="width: 200px; margin-left: 10px"
        placeholder="手机号"
        clearable
        @clear="clear"
      />
      <el-input
        v-model.trim="queryData.code"
        style="width: 200px; margin-left: 10px"
        placeholder="用户ID"
        clearable
        @clear="clear"
      />
      <el-input
        v-model.trim="queryData.parentCode"
        style="width: 200px; margin-left: 10px"
        placeholder="上级ID"
        clearable
        @clear="clear"
      />
      <el-select
        v-model="queryData.vipLevel"
        placeholder="VIP等级"
        style="margin: 0 10px; width: 200px"
        clearable
        @clear="clear"
      >
        <el-option
          v-for="(item, index) in vipList"
          :key="index"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button class="search" type="primary" @click="search">搜索</el-button>
    </el-form>
    <el-table
      class="table"
      :data="tableData"
      :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }"
      highlight-current-row
      style="width: 98.5%; margin-top: 30px; margin-left: 0px"
    >
      <el-table-column prop="code" label="ID" width="90" />

      <el-table-column
        prop="mobile"
        label="手机号"
        width="110"
        :show-overflow-tooltip="true"
      />

      <el-table-column
        prop="parentUserId"
        width="80"
        label="上级ID"
      />
      <el-table-column
        prop="belongCusotmerService"
        width="80"
        label="归属客服"
        show-overflow-tooltip
      />
      <el-table-column prop="inviteUserCount" label="邀请人数" width="70">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="inviteUserCount(scope.row)"
          >
            {{ scope.row.inviteUserCount }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="proxyEmployee" label="所属代理" />
      <el-table-column
        prop="remainLotteryCount"
        label="剩余抽奖次数"
      />
      <el-table-column prop="rechargeFlag" label="是否首充" width="60">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.rechargeFlag == 1" type="success">是</el-tag>
          <el-tag v-else type="danger">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="vipLevel" label="VIP" width="50" />
      <el-table-column
        prop="commissionTotalAmount"
        label="总佣金"
      />
      <el-table-column prop="awardTotalAmount" label="总收益" />
      <el-table-column
        prop="rechargeTotalAmount"
        label="总充值"
        width="120"
      />
      <el-table-column
        prop="withDrawTotalAmount"
        label="总提现"
      />
      <el-table-column prop="balance" label="余额" />
      <el-table-column prop="freezeAmount" label="冻结余额" />

      <el-table-column
        prop="created"
        label="注册时间"
        width="160"
      />
      <el-table-column
        prop="lastLoginTime"
        label="最后登录时间"
        width="160"
      />
      <el-table-column width="80" label="前端登录">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="frontendLogin(scope.row)">
            前端登录
          </el-button>
        </template>
      </el-table-column>
      <el-table-column v-if="mskUserName == 'admin'" width="50" label="封禁">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.accountStatus == '0'"
            type="text"
            size="small"
            @click="banUser(scope.row)"
          >
            解封
          </el-button>
          <el-button
            v-if="scope.row.accountStatus == '1'"
            type="text"
            size="small"
            @click="banUser(scope.row)"
          >
            封禁
          </el-button>
        </template>
      </el-table-column>
      <el-table-column v-if="mskUserName == 'admin'" width="50" label="充值">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="rechargeBtn('recharge', scope.row)"
          >
            充值
          </el-button>
        </template>
      </el-table-column>
      <el-table-column v-if="mskUserName == 'admin'" width="50" label="扣款">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="rechargeBtn('deduction', scope.row)"
          >
            扣款
          </el-button>
        </template>
      </el-table-column>
      <!-- <el-table-column width="70" label="购买记录">
        <template slot-scope="scope">
          <el-button type="text" @click="flowingWater(scope.row)" size="small">
            购买记录
          </el-button>
        </template>
      </el-table-column> -->
      <el-table-column label="更多" width="80" fixed="right">
        <template slot-scope="scope">
          <el-dropdown trigger="click">
            <span class="el-dropdown-link">
              更多<i class="el-icon-arrow-down el-icon--right" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item>
                <el-button type="text" size="small" @click="tixian(scope.row,'0')" v-if="scope.row.allowWithdrawalFlag == '0'">
                  允许提现
                </el-button>
                <el-button type="text" size="small" @click="tixian(scope.row,'1')" v-if="scope.row.allowWithdrawalFlag == '1'">
                  禁止提现
                </el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button type="text" size="small" @click="touzi(scope.row,'0')" v-if="scope.row.allowInvestFlag == '0'">
                  允许投资
                </el-button>
                <el-button type="text" size="small" @click="touzi(scope.row,'1')" v-if="scope.row.allowInvestFlag == '1'">
                  禁止投资
                </el-button>
              </el-dropdown-item> -->
              <el-dropdown-item>
                <el-button
                  type="text"
                  size="small"
                  @click="resetPassword(scope.row, '1')"
                >
                  重置密码
                </el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  type="text"
                  size="small"
                  @click="resetPassword(scope.row, '2')"
                >
                  重置提款密码
                </el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  type="text"
                  size="small"
                  @click="ResetBankCard(scope.row)"
                >
                  重置银行卡
                </el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  type="text"
                  size="small"
                  @click="information(scope.row)"
                >
                  详细信息
                </el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  type="text"
                  size="small"
                  @click="QuerySuperior(scope.row)"
                >
                  上级关系
                </el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  type="text"
                  size="small"
                  @click="flowingWater(scope.row)"
                >
                  购买记录
                </el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  type="text"
                  size="small"
                  @click="performance(scope.row)"
                >
                  查看业绩
                </el-button>
              </el-dropdown-item>
              <el-dropdown-item v-if="mskUserName == 'admin'">
                <el-button
                  v-if="scope.row.accountStatus == '0'"
                  type="text"
                  size="small"
                  @click="bannedTeam(scope.row)"
                >
                  解封团队
                </el-button>
                <el-button
                  v-else
                  type="text"
                  size="small"
                  @click="bannedTeam(scope.row)"
                >
                  封禁团队
                </el-button>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      background
      :current-page="queryData.pageNo"
      :page-sizes="[10, 35, 50, 100, 200, 500]"
      :page-size="queryData.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    <!-- 充值 -->
    <el-dialog
      :title="title"
      :visible.sync="rechargeVisible"
      style="width: 60%; margin: 0 0 0 400px"
    >
      <el-form :model="amountForm">
        <el-form-item :label="title + ':'" :label-width="formLabelWidth">
          <el-input
            v-model="amountForm.amount"
            autocomplete="off"
            placeholder="请输入金额"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          class="cancel"
          @click="rechargeVisible = false"
        >取 消</el-button>
        <el-button
          type="primary"
          :disabled="isButtonDisabled"
          @click="rechargeVisibleVisibleClk"
        >确 定</el-button>
      </div>
    </el-dialog>
    <!-- 重置密码 -->
    <el-dialog
      :title="passTitle"
      :visible.sync="editdialogFormVisible"
      style="width: 60%; margin: 0 0 0 400px"
    >
      <el-form :model="rechargeForm">
        <el-form-item label="密码:" :label-width="formLabelWidth">
          <el-input
            v-model="rechargeForm.password"
            autocomplete="off"
            placeholder="请输入密码"
            style="width: 80%"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          class="cancel"
          @click="editdialogFormVisible = false"
        >取 消</el-button>
        <el-button
          type="primary"
          @click="editdialogFormVisibleClk"
        >确 定</el-button>
      </div>
    </el-dialog>
    <!-- 账单记录 -->
    <el-dialog title="购买记录" :visible.sync="billingRecords" width="70%">
      <el-table :data="gridData">
        <el-table-column property="id" label="id" />
        <el-table-column
          property="productName"
          label="商品名称"
        />
        <el-table-column property="amount" label="金额" />
        <el-table-column property="created" label="购买时间" />
        <el-table-column property="orderNo" label="订单编号" />
        <el-table-column property="limitDate" label="产品到期剩余时间">
          <template slot-scope="scope">
            <span
              v-if="scope.row.cycleType == 2"
            >{{ scope.row.limitDate }}天</span>
            <span
              v-if="scope.row.cycleType == 1"
            >{{ scope.row.limitDate }}小时</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        background
        :current-page="gridQueryData.pageNo"
        :page-sizes="[10, 35, 50, 100, 200, 500]"
        :page-size="gridQueryData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="gridTotle"
        @size-change="gridHandleSizeChange"
        @current-change="gridhandleCurrentChange"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="billingRecords = false">取 消</el-button>
        <el-button
          type="primary"
          @click="dialogVisible = false"
        >确 定</el-button>
      </span>
    </el-dialog>
    <!-- 用户详细信息 -->
    <el-dialog
      title="用户详细信息"
      :visible.sync="informationDialog"
      width="40%"
    >
      <el-form :model="userForm">
        <el-form-item label="VIP:" :label-width="formLabelWidth">
          <el-input
            v-model="userForm.vipLevel"
            autocomplete="off"
            style="width: 90%"
          />
        </el-form-item>
        <el-form-item label="手机号:" :label-width="formLabelWidth">
          <el-input
            v-model="userForm.mobile"
            autocomplete="off"
            placeholder="手机号"
            style="width: 90%"
          />
        </el-form-item>
        <!-- <el-form-item label="邮箱:" :label-width="formLabelWidth">
          <el-input
            v-model="userForm.userEmail"
            autocomplete="off"
            placeholder="邮箱"
            style="width: 90%"
          ></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="登录状态:" :label-width="formLabelWidth">
          <el-radio-group v-model="userForm.accountStatus">
            <el-radio :label="true">正常</el-radio>
            <el-radio :label="false">禁用</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="违规开关:" :label-width="formLabelWidth">
          <el-radio-group v-model="userBasicInfo.violationCheckSwitchFlag">
            <el-radio :label="true">正常</el-radio>
            <el-radio :label="false">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="收益开关:" :label-width="formLabelWidth">
          <el-radio-group v-model="userBasicInfo.profitSwitchFlag">
            <el-radio :label="true">正常</el-radio>
            <el-radio :label="false">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="分红开关:" :label-width="formLabelWidth">
          <el-radio-group v-model="userBasicInfo.dividendSwitchFlag">
            <el-radio :label="true">正常</el-radio>
            <el-radio :label="false">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="红包开关:" :label-width="formLabelWidth">
          <el-radio-group v-model="userBasicInfo.redpackSwitchFlag">
            <el-radio :label="true">正常</el-radio>
            <el-radio :label="false">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="佣金开关:" :label-width="formLabelWidth">
          <el-radio-group v-model="userBasicInfo.commissionSwitchFlag">
            <el-radio :label="true">正常</el-radio>
            <el-radio :label="false">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="充值状态:" :label-width="formLabelWidth">
          <el-radio-group v-model="userBasicInfo.rechargeSwitchFlag">
            <el-radio :label="true">正常</el-radio>
            <el-radio :label="false">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="提现状态:" :label-width="formLabelWidth">
          <el-radio-group v-model="userBasicInfo.allowWithdrawalFlag">
            <el-radio label="1">正常</el-radio>
            <el-radio label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="提现状态:" :label-width="formLabelWidth">
          <el-radio-group v-model="radio">
            <el-radio :label="true">正常</el-radio>
            <el-radio :label="false">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="VIP状态:" :label-width="formLabelWidth">
          <el-radio-group v-model="radio">
            <el-radio :label="true">系统自行判断</el-radio>
            <el-radio :label="false">后台手动设置</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <!-- <el-form-item label="团队返利余额:" :label-width="formLabelWidth">
          <el-input
            autocomplete="off"
            placeholder="状态"
            style="width: 90%"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="单笔最大充值:" :label-width="formLabelWidth">
          <el-input
            v-model="userBasicInfo.maxRechargeAmount"
            autocomplete="off"
            placeholder="单笔最大充值"
            style="width: 90%"
          />
        </el-form-item>
        <el-form-item label="单笔最大提现:" :label-width="formLabelWidth">
          <el-input
            v-model="userBasicInfo.maxWithdrawAmount"
            autocomplete="off"
            placeholder="单笔最大提现"
            style="width: 90%"
          />
        </el-form-item>

        <el-form-item label="状态:" :label-width="formLabelWidth">
          <el-input
            v-model="userForm.accountStatus"
            disabled
            autocomplete="off"
            placeholder="状态"
            style="width: 90%"
          />
        </el-form-item>
        <el-form-item label="密码:" :label-width="formLabelWidth">
          <el-input
            v-model="userForm.loginPassword"
            disabled
            autocomplete="off"
            placeholder="密码"
            style="width: 90%"
          />
        </el-form-item>
        <el-form-item label="注册时间:" :label-width="formLabelWidth">
          <el-input
            v-model="userForm.createdTime"
            disabled
            autocomplete="off"
            placeholder="注册时间"
            style="width: 90%"
          />
        </el-form-item>

        <el-form-item label="提现密码:" :label-width="formLabelWidth">
          <el-input
            v-model="userForm.withdrawPlainPassword"
            autocomplete="off"
            placeholder="提现密码"
            style="width: 90%"
          />
        </el-form-item>
        <!-- <el-form-item label="登录密码:" :label-width="formLabelWidth">
          <el-button type="primary" plain>重置</el-button>
        </el-form-item>
        <el-form-item label="银行卡:" :label-width="formLabelWidth">
          <el-button type="primary" plain>重置</el-button>

        </el-form-item> -->
        <el-form-item label="银行卡:" :label-width="formLabelWidth">
          <el-table
            :data="userFormList"
            border
            :header-cell-style="{ 'text-align': 'center' }"
            :cell-style="{ 'text-align': 'center' }"
          >
            <el-table-column property="name" label="名称" />
            <el-table-column property="mobile" label="手机号" />
            <el-table-column
              property="accountNumber"
              label="账号"
            />
            <el-table-column
              property="backName"
              label="银行名称"
            />
            <el-table-column property="email" label="邮箱" />
            <!-- <el-table-column property="ifscCode" label="IFSC"></el-table-column> -->
          </el-table>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="informationDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="informationDialogClk"
        >确 定</el-button>
      </span>
    </el-dialog>
    <!-- 查看业绩 -->
    <el-dialog
      title="查看业绩"
      :visible.sync="performanceDialogVisible"
      width="30%"
      center
    >
      <div class="performanceInfo">
        <div class="left">
          <span>下级推广人数：{{
            performanceInfo.inviteChildrenUserCount || 0
          }}</span>
          <span>下级总充值：{{
            performanceInfo.childrenUserRechargeAmount || 0
          }}</span>
          <span>下级总提现：{{
            performanceInfo.childrenUserWithdrawAmount || 0
          }}</span>
          <span>首充人数：{{
            performanceInfo.childrenFirstRechargeUserCount || 0
          }}</span>
          <span>复充人数：{{
            performanceInfo.childrenAgainRechargeUserCount || 0
          }}</span>
        </div>
        <div class="right">
          <span>下级今日推广人数：{{
            performanceInfo.inviteChildrenUserTodayCount || 0
          }}</span>
          <span>下级今日充值：{{
            performanceInfo.childrenUserTodayRechargeAmount || 0
          }}</span>
          <span>下级今日提现：{{
            performanceInfo.childrenUserTodayWithdrawAmount || 0
          }}</span>
          <span>今日首充人数：{{
            performanceInfo.childrenTodayFirstRechargeUserCount || 0
          }}</span>
          <span>今日复充人数：{{
            performanceInfo.childrenTodayAgainRechargeUserCount || 0
          }}</span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="performanceDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="performanceDialogVisible = false"
        >确 定</el-button>
      </span>
    </el-dialog>
    <!-- 查询上级用户 -->
    <el-dialog
      title="上级用户关系"
      :visible.sync="QuerySuperiorDialog"
      style="width: 60%; margin: 0 0 0 400px"
    >
      <el-form>
        <el-form-item>
          <el-timeline>
            <el-timeline-item
              v-for="(activity, index) in QuerySuperiorList"
              :key="index"
            >
              {{ activity }}
            </el-timeline-item>
          </el-timeline>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          class="cancel"
          @click="QuerySuperiorDialog = false"
        >取 消</el-button>
        <el-button
          type="primary"
          :disabled="isButtonDisabled"
          @click="QuerySuperiorDialog = false"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { get, post } from '@/utils/request'
const moment = require('moment')
moment.locale('zh-cn')
export default {
  name: 'UserManageStatic',
  components: {},
  data() {
    return {
      mskUserName: '',
      radio: '',
      performanceDialogVisible: false,
      amountForm: {
        userId: '',
        amount: '',
        businessType: ''
      },
      title: '',
      rechargeVisible: false,
      billingRecords: false,
      gridData: [],
      gridTotle: 0,
      gridQueryData: {
        pageSize: 10,
        pageNo: 1,
        userId: ''
      },
      queryData: {
        pageSize: 10,
        pageNo: 1,
        mobile: '',
        startTime: '',
        endTime: '',
        userClassify: '1', // 1是有效 ，0是无效
        code: '', // 用户id
        parentCode: '', // 上级id
        vipLevel: '' // vip等级
      },
      total: 0,
      time: '',
      date: '',
      tableData: [],
      editdialogFormVisible: false,
      formLabelWidth: '150px',
      // 编辑
      rechargeForm: {
        userId: '',
        password: '', // 登录密码
        // LOGIN_PASSWORD 登录密码,WITHDRAW_PASSWORD 提现密码
        resetType: ''
      },
      passTitle: '',

      Distribution: {
        id: '',
        taskMode: '',
        taskModeId: ''
      },
      currentRow: null,
      isButtonDisabled: false,
      userId: '',
      userForm: {
        id: '',
        mobile: '',
        userEmail: '',
        accountStatus: '', // 状态
        loginPassword: '', // 密码
        createdTime: '', // 注册时间
        level: '', // 人数
        withdrawPlainPassword: '', // 提现密码
        withdrawPassword: '',
        maxRechargeAmount: '', // 单笔最大充值
        maxWithdrawAmount: '' // 单笔最大提现
      },
      userBasicInfo: {
        commissionSwitchFlag: '', // 佣金开关
        dividendSwitchFlag: '', // 分红开关
        profitSwitchFlag: '', // 收益开关
        rechargeSwitchFlag: '', //	充值开关
        redpackSwitchFlag: '', //	红包开关
        violationCheckSwitchFlag: '', // 违规开关
        allowWithdrawalFlag: '' // 提现开关 0 不允许1允许
      },
      informationDialog: false,

      userFormList: [],
      performanceInfo: {
        inviteChildrenUserCount: '', // 下级推广人数
        childrenUserRechargeAmount: '', // 下级总充值
        childrenUserWithdrawAmount: '', // 下级总提现
        childrenFirstRechargeUserCount: '', // 首充人数
        childrenAgainRechargeUserCount: '', // 复充人数
        inviteChildrenUserTodayCount: '', // 下级今日推广人数
        childrenUserTodayRechargeAmount: '', // 下级今日充值
        childrenUserTodayWithdrawAmount: '', // 下级今日提现
        childrenTodayAgainRechargeUserCount: '', // 今日复充人数
        childrenTodayFirstRechargeUserCount: '' // 今日首充人数
      },
      // 上级用户关系
      QuerySuperiorDialog: false,
      QuerySuperiorList: [],
      sysVal:"",
      vipList: [
        {
          label: 'VIP1',
          value: '1'
        },
        {
          label: 'VIP2',
          value: '2'
        },
        {
          label: 'VIP3',
          value: '3'
        },
        {
          label: 'VIP4',
          value: '4'
        },
        {
          label: 'VIP5',
          value: '5'
        },
        {
          label: 'VIP6',
          value: '6'
        },
        {
          label: 'VIP7',
          value: '7'
        },
        {
          label: 'VIP8',
          value: '8'
        },
        {
          label: 'VIP9',
          value: '9'
        },
        {
          label: 'VIP10',
          value: '10'
        }
      ]
    }
  },
  created() {
    this.mskUserName = localStorage.getItem('mskUserName')
    this.getList()
    this.getSystem()
  },
  methods: {
     // 获取系统配置
     getSystem() {
      post("/admin/sysconfig/page", {}).then((res) => {
        console.log(res);
        let data = res.data.data.data.find(
          (item) => item.sysKey == "MAIN_DOMAIN"
        );
        // this.sysVal = data.sysVal;
        this.sysVal = data.sysVal.split(',')[0]
      });
    },

    // 上级用户关系
    QuerySuperior(row) {
      this.QuerySuperiorDialog = true
      post('/admin/app/user/findParentRelation', {
        id: row.id
      }).then((res) => {
        if (res.data.code == 20000) {
          this.$message({
            type: 'success',
            message: res.data.message
          })
          // console.log(res.data.data);
          this.QuerySuperiorList = res.data.data.parentRelationLink
          this.QuerySuperiorList.push(row.code)
        } else {
          this.$message({
            type: 'info',
            message: res.data.message
          })
        }
      })
    },
    // 点击人数跳转
    inviteUserCount(row) {
      console.log(row)
      this.$router.push({
        path: '/trade_manage/team_data_manage',
        query: {
          mobile: row.mobile
        }
      })
    },
    // 封禁/解封团队
    bannedTeam(row) {
      this.$confirm('此操作将封禁/解封整个团队, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let accountStatus = ''
        if (row.accountStatus == '0') {
          accountStatus = 'WHITE'
        } else {
          accountStatus = 'BLACK'
        }
        post('/admin/app/user/modifyTeamUserAccountStatus', {
          userId: row.id,
          accountStatus
        }).then((res) => {
          if (res.data.code == 20000) {
            this.$message({
              type: 'success',
              message: res.data.message
            })
            this.getList()
          } else {
            this.$message({
              type: 'info',
              message: res.data.message
            })
          }
        })
      })
    },
    // 查看业绩
    performance(row) {
      this.performanceDialogVisible = true
      post('/admin/app/user/queryUserPerformance', { id: row.id }).then(
        (res) => {
          this.performanceInfo = res.data.data
        }
      )
    },
    // 详细信息
    information(row) {
      // console.log(row);
      this.userId = row.id
      const id = row.id
      this.informationDialog = true
      post('/admin/app/user/queryUserDetailInfo', { id }).then((res) => {
        this.userFormList = res.data.data.bankCards
        this.userForm = res.data.data.accountInfo
        this.userBasicInfo = res.data.data.userBasicInfo
        if (res.data.data.accountInfo.accountStatus == '0') {
          this.userForm.accountStatus = '正常'
        } else {
          this.userForm.accountStatus = '封禁'
        }
      })
    },
    // 详细信息更新
    informationDialogClk() {
      if ((this.userForm.accountStatus = '正常')) {
        this.userForm.accountStatus = 1
      } else {
        this.userForm.accountStatus = 0
      }

      this.userForm.id = this.userId
      this.userForm.withdrawPassword = this.userForm.withdrawPlainPassword
      this.informationDialog = false
      this.userForm = { ...this.userBasicInfo, ...this.userForm }
      if (this.userForm.mobile.length != 10) {
        return this.$message.error('手机号不是十位数')
      }
      post('/admin/app/user/update', this.userForm).then((res) => {
        if (res.data.code == 20000) {
          this.$message({
            type: 'success',
            message: res.data.message
          })
          this.getList()
        } else {
          this.$message({
            type: 'info',
            message: res.data.message
          })
        }
      })
    },
    touzi(row, num) {
      let text = ''
      const id = row.id
      let allowInvestFlag = ''
      if (num == '0') {
        (text = '允许'), (allowInvestFlag = '1')
      } else {
        text = '不允许'
        allowInvestFlag = '0'
      }
      this.$confirm(text + '给此用户提现？, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 1->允许 0->不允许

          post('/admin/app/user/save', { allowInvestFlag, id }).then((res) => {
            // console.log(res);
            if (res.data.code != 20000) {
              this.$message({
                type: 'info',
                message: res.data.message
              })
            }
            this.$message({
              type: 'success',
              message: res.data.message
            })
            this.getList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    tixian(row, num) {
      let text = ''
      const id = row.id
      let allowWithdrawalFlag = ''
      if (num == '0') {
        (text = '允许'), (allowWithdrawalFlag = '1')
      } else {
        text = '不允许'
        allowWithdrawalFlag = '0'
      }
      this.$confirm(text + '给此用户提现？, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 1->允许 0->不允许

          post('/admin/app/user/save', { allowWithdrawalFlag, id }).then(
            (res) => {
              // console.log(res);
              if (res.data.code != 20000) {
                this.$message({
                  type: 'info',
                  message: res.data.message
                })
              }
              this.$message({
                type: 'success',
                message: res.data.message
              })
              this.getList()
            }
          )
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 前端登录
    frontendLogin(row) {
      const mobile = row.mobile
      const encryptPassword = row.password
      // let http = window.location.origin;
      const domainUrl = window.location.hostname
      let url = ''
      if (domainUrl == 'www.osmsc.top') {
        url = `https://www.osmsc.top/lanpage/#/?mobile=${mobile}&password=${encryptPassword}&identityType=USER&mode=MOBILE&country=BR`
      } else {
        //  url = `https://www.maerskk.com/#/?mobile=${mobile}&password=${encryptPassword}&identityType=USER&mode=MOBILE&country=BR`;
        if (process.env.NODE_ENV === 'production') {
          // console.log('当前是生产环境');
          url = `${this.sysVal}/#/?mobile=${mobile}&password=${encryptPassword}&identityType=USER&mode=MOBILE&country=BR`
        } else {
          url = `http://192.168.110.100:8080/#/?mobile=${mobile}&password=${encryptPassword}&identityType=USER&mode=MOBILE&country=BR`
        }
      }
      // let url = `http://192.168.110.100:8080/#/?mobile=${mobile}&password=${encryptPassword}&identityType=USER&mode=MOBILE&country=BR`;
      // window.location.href = url
      window.open(url, '_blank')
    },
    // 重置登录/提现密码
    resetPassword(row, num) {
      // 1 登录密码  2  提现密码
      if (num == '1') {
        this.passTitle = '重置登录密码'
        this.rechargeForm.resetType = 'LOGIN_PASSWORD'
        this.rechargeForm.password = '123456'
      } else {
        this.passTitle = '重置提现密码'
        this.rechargeForm.resetType = 'WITHDRAW_PASSWORD'
        this.rechargeForm.password = 'zxcvbnm'
      }
      this.editdialogFormVisible = true
      this.rechargeForm.userId = row.id
    },
    // 重置登录密码确定
    editdialogFormVisibleClk() {
      post('/admin/app/user/account/password/reset', this.rechargeForm).then(
        (res) => {
          if (res.data.code != 20000) {
            return this.$message({
              message: res.data.message,
              type: 'error'
            })
          }
          this.getList()
          this.editdialogFormVisible = false
          this.$message({
            message: res.data.message,
            type: 'success'
          })
        }
      )
    },
    // 充值/扣款
    rechargeBtn(name, item) {
      // console.log(item);
      this.amountForm.amount = ''
      if (name == 'recharge') {
        this.title = '充值'
        this.amountForm.businessType = 'ADMIN_BALANCE_RECHARGE'
      } else {
        this.title = '扣款'
        this.amountForm.businessType = 'ADMIN_BALANCE_REDUCE'
      }
      this.amountForm.userId = item.id
      this.rechargeVisible = true
    },
    // 充值金额
    rechargeVisibleVisibleClk() {
      if (this.amountForm.amount == '' || this.amountForm.amount == '0') {
        this.$message({
          message: '金额不能为空',
          type: 'error'
        })
        return
      }
      post('/admin/app/user/balance/update', this.amountForm).then((res) => {
        if (res.data.code != 20000) {
          this.$message({
            message: res.data.message,
            type: 'error'
          })
          return
        }
        this.$message({
          message: res.data.message,
          type: 'success'
        })
        this.rechargeVisible = false
        this.getList()
      })
    },
    // 拉黑/洗白
    banUser(row) {
      const userId = row.id
      // console.log(row);
      const message = row.accountStatus == '0' ? '解封此用户' : '封禁此用户'
      this.$confirm(message + ',' + '是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let accountStatus
          if (row.accountStatus == '1') {
            accountStatus = 'BLACK'
          } else {
            accountStatus = 'WHITE'
          }
          post('/admin/app/user/account/status/update', {
            accountStatus,
            userId
          }).then((res) => {
            console.log(res)
            if (res.data.code == 20000) {
              this.$message({
                message: res.data.message,
                type: 'success'
              })
            }
            this.getList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 购买记录
    flowingWater(row) {
      const userId = row.id
      this.billingRecords = true
      post('/admin/app/user/product/buy/list', { userId }).then((res) => {
        // console.log(res.data.data);
        this.gridTotle = res.data.data.total
        this.gridData = res.data.data.list
      })
    },
    gridHandleSizeChange(val) {
      this.gridQueryData.pageSize = val
      this.flowingWater()
    },
    gridhandleCurrentChange(val) {
      this.gridQueryData.pageNo = val
      this.flowingWater()
    },

    // 重置银行卡
    ResetBankCard(row) {
      const userId = row.id
      post('/admin/app/user/bankcard/reset', { userId }).then((res) => {
        // console.log(res);
        if (res.data.code != 20000) {
          return this.$message({
            message: res.data.message,
            type: 'error'
          })
        }
        this.getList()
        this.$message({
          message: res.data.message,
          type: 'success'
        })
      })
    },

    getList() {
      post('/admin/app/user/findPage', this.queryData).then((res) => {
        this.total = res.data.data.total
        this.tableData = res.data.data.list
      })
    },
    handleSizeChange(val) {
      this.queryData.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.queryData.pageNo = val
      this.getList()
    },
    clear() {
      this.getList()
    },
    search() {
      this.queryData.pageNo = 1
      this.$nextTick(() => {})
      if (!this.date == false) {
        this.queryData.startTime = moment(this.date[0]).format('YYYY-MM-DD')
        this.queryData.endTime = moment(this.date[1]).format('YYYY-MM-DD')
        post('/admin/app/user/findPage', this.queryData).then((res) => {
          this.total = res.data.data.total
          this.tableData = res.data.data.list
          this.$message({
            message: res.data.message,
            type: 'success'
          })
        })
      } else {
        this.queryData.startTime = ''
        this.queryData.endTime = ''
        post('/admin/app/user/findPage', this.queryData).then((res) => {
          this.total = res.data.data.total
          this.tableData = res.data.data.list
          this.$message({
            message: res.data.message,
            type: 'success'
          })
        })
      }
    }
  }
}
</script>
<style scoped lang="scss">
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.performanceInfo {
  display: flex;
  justify-content: space-evenly;
  span {
    line-height: 30px;
  }
}
.left {
  display: flex;
  flex-direction: column;
}
.right {
  display: flex;
  flex-direction: column;
}
.el-timeline-item__wrapper {
  top: -12px !important;
}
</style>
